export default {
    setTitle(title) {
        document.title = title;
    },
    tabSelect( tabName, option = 'tabs' ) {
        tabName = tabName || this.tabs[this.$route.query.tab] || option;
        if ( !this.tabs[tabName] ) {
            for ( let tab in this.tabs ) {
                if ( this.tabs.hasOwnProperty(tab) ) {
                    this.tabs[tab] = tabName === tab;
                }
            }
        }
    },
    snotifyError( msg, timer = 3000 ) {
        return this.$snotify.error(msg, {
            timeout: timer,
        });
    },
    formLoader() {
        this.loader = this.$loading.show()
    },
    formHideLoader() {
        this.loader.hide();
    }
}
